import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';

export const PROJECT_PORTAL_WORKSPACES = ['overview', 'project_record', 'reporting_periods', 'documents'];

const PROJECT_RECORD_PAGES = new Set([
    'site_scheme',
    'conditions',
    'programme',
    'design_team',
    'procurement',
    'costs',
    'cost_tables',
    'drawdown',
    'insurance',
    'approved_evidence'
]);

export function resolveProjectPortalWorkspace(workspace, page) {
    const requestedWorkspace = String(workspace || '').trim().toLowerCase();
    const requestedPage = String(page || '').trim().toLowerCase();
    if (requestedPage === 'risk') return 'reporting_periods';
    if (requestedPage === 'activity' && requestedWorkspace === 'project_record') return 'overview';
    if (PROJECT_PORTAL_WORKSPACES.includes(requestedWorkspace)) return requestedWorkspace;

    if (requestedPage === 'documents') return 'documents';
    if (PROJECT_RECORD_PAGES.has(requestedPage)) return 'project_record';
    if (requestedPage === 'initial' || requestedPage === 'interim') return 'reporting_periods';
    return 'overview';
}

const NAV_ITEMS = [
    { key: 'overview', label: 'Overview', icon: DashboardOutlinedIcon },
    { key: 'project_record', label: 'Project Record', icon: AssignmentOutlinedIcon },
    { key: 'reporting_periods', label: 'Reporting Periods', icon: CalendarMonthOutlinedIcon },
    { key: 'documents', label: 'Documents', icon: FolderOutlinedIcon }
];

export default function ProjectPortalNavigation({ activeWorkspace, onChange }) {
    return (
        <Paper
            component="nav"
            aria-label="Project information"
            variant="outlined"
            sx={{
                p: 0.75,
                borderRadius: 1,
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                overflow: 'hidden',
                backgroundColor: (theme) => alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.84 : 0.94),
                boxShadow: 'none'
            }}
        >
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(4, minmax(0, 1fr))' }, gap: 0.75, minWidth: 0 }}>
                {NAV_ITEMS.map((item) => {
                    const selected = item.key === activeWorkspace;
                    const Icon = item.icon;
                    return (
                        <Button
                            key={item.key}
                            type="button"
                            aria-current={selected ? 'page' : undefined}
                            onClick={() => onChange(item.key)}
                            startIcon={<Icon fontSize="small" />}
                            sx={{
                                minHeight: { xs: 48, sm: 42 },
                                borderRadius: 0.75,
                                justifyContent: 'flex-start',
                                px: { xs: 1, sm: 1.5 },
                                color: selected ? 'primary.main' : 'text.secondary',
                                backgroundColor: selected ? (theme) => alpha(theme.palette.primary.main, 0.11) : 'transparent',
                                border: '1px solid',
                                borderColor: selected ? (theme) => alpha(theme.palette.primary.main, 0.3) : 'transparent',
                                '&:hover': {
                                    backgroundColor: (theme) => alpha(theme.palette.primary.main, selected ? 0.15 : 0.07)
                                }
                            }}
                        >
                            <Typography component="span" sx={{ fontSize: 13, lineHeight: 1.2, fontWeight: selected ? 850 : 700 }}>
                                {item.label}
                            </Typography>
                        </Button>
                    );
                })}
            </Box>
        </Paper>
    );
}